var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourceInstitute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Institute"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6744 2.00002L2.50056 6.63367V9.04434H21.5006V6.62088L11.6744 2.00002ZM20.2339 7.71555H3.76723V7.46865L11.6934 3.46518L20.2339 7.48144V7.71555ZM3.76723 18.3459H20.2339V19.6746H3.76723V18.3459ZM2.50056 20.6712H21.5006V22H2.50056V20.6712ZM4.0839 10.3731H5.35056V17.0171H4.0839V10.3731ZM18.6506 10.3731H19.9172V17.0171H18.6506V10.3731ZM14.8506 10.3731H16.1172V17.0171H14.8506V10.3731ZM7.8839 10.3731H9.15056V17.0171H7.8839V10.3731ZM11.3672 10.3731H12.6339V17.0171H11.3672V10.3731Z",
    fill: "#0D70DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceInstitute);
export default __webpack_public_path__ + "static/media/source-institute.cdc74d45d7a3e50be08f04aa0ac657b5.svg";
export { ForwardRef as ReactComponent };